import {Injectable} from "@angular/core";
import {LocalStorageService} from "@biletix/core/services/local-storage.service";
import {StorageKey} from "@biletix/core/services/storage.service";

@Injectable({
  providedIn: "root"
})
export class CustomerTokenService {

  constructor(
    private localStorage: LocalStorageService,
  ) {}
  getToken() {
    let token = this.localStorage.get(StorageKey.CUSTOMERTOKEN);
    if (token) {
      return token;
    }
    return null
  }
  getAppVersion() {
    let version = this.localStorage.get(StorageKey.APPVERSION);
    if (version) {
      return version;
    }
    return null
  }

}
